import { useEffect, useState } from "react"

//hooks
import useFetch from "hooks/useFetch"
import useIsLoading from "hooks/useIsLoading"

//constants
import { ENDPOINTS } from "constants/endpoints"

//helpers
import { getGETParam, getUrlData } from "helpers/url"

//providers
import { useFinanceDataContext } from "../providers/finances"
import useEditFinance from "./useEditFinance"

function useFetchFinancesTable(categoryId, userId,clientId,workOrderId) {   

    const financeProvider = useFinanceDataContext()

    const { fetch } = useFetch()
    const { loading, setLoading } = useIsLoading(true)
    const [finances, setFinances] = useState({
        days: []
    })

    useEffect(()=> {
        fetchFinances(getGETParam(financeProvider.filters),categoryId, userId,clientId,workOrderId)
    },[financeProvider.handleRefresh().getRefreshed(),categoryId, userId,clientId,workOrderId])    

    function fetchFinances(params,categoryId, userId,clientId,workOrderId) {
        setLoading(true)

       if(!params) return
        fetch({            
            endpoint: `${ENDPOINTS.SHARED.GET_FINANCES_TABLE}${params}&worker_id=${userId}&category_id=${categoryId}&client_id=${clientId}&order_id=${workOrderId}`,            
            method: "get",
        })
            .then((res) => {
                setFinances(res.data)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    function getFinances() {
        return finances
    }

    function getFinancesEntries() {
        return Object.values(getFinances())
    }

    return {
        getFinances,
        getFinancesEntries,
        fetchFinances,
        loading,
        setLoading,
    }
}

export default useFetchFinancesTable